import React from 'react';
/* Holds a label and input for bogo form components. */
const BogoFormField = (props) => {
    return(
        <div className="discount-edit-field">
            {!!props.item.errors && !!props.item.errors[props.field] && <div className="error msg_animate">{props.item.errors[props.field]}</div>}
            <div className='discount-edit-label'>{props.label}:</div>
            <input type={props.type} value={props.item[props.field] === null ? '' : props.item[props.field]} placeholder="Enter coupon code" onChange={e => props.handleChange(e.target.value, props.field)}/>
        </div>
    )
}

export default BogoFormField


// WEBPACK FOOTER //
// ./src/components/admin/discounts/BuyXGetYField.js